import { render, staticRenderFns } from "./Issue1.vue?vue&type=template&id=f3d7e98c&scoped=true&"
import script from "./Issue1.vue?vue&type=script&lang=js&"
export * from "./Issue1.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=f3d7e98c&prod&scoped=true&lang=css&"
import style1 from "./Issue1.vue?vue&type=style&index=1&id=f3d7e98c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d7e98c",
  null
  
)

export default component.exports